import React from 'react';

import './NotificationHeader.scss';

const NotificationHeader = (props) => {
    return (
        <header className={props.containerClasses}>
            {props.renderIcon && props.renderIcon('notification-header__icon')}
            {props.children}
        </header>
    );
};

export default NotificationHeader;
